import { Box, Button, FormControl, Grid, Input, InputLabel, makeStyles, MenuItem, MenuItemGroup, OutlinedInput, Select, TextField, Divider, useTheme, useMediaQuery, IconButton, Checkbox } from "@material-ui/core";
import {useEffect, useState} from "react";
import {useTranslation} from "react-i18next";
import _ from "lodash";
import {Autocomplete} from "@material-ui/lab";
import {withStyles} from "@material-ui/styles";
import RemoveIcon from '@material-ui/icons/Remove';
import { CloudDownload, Search } from "@material-ui/icons";
import {useToken} from "../../../utilities/hooks";
import { getUserPreference } from "../../../utilities/common";
import { useSelector } from "react-redux";

const MANAGER_ACCESS_ROLE = 307;

const useStyle = makeStyles((theme) => ({
    root: {
        display: 'flex',
        justifyContent: 'space-between',
        borderTop: '1px grey solid',
        borderBottom: '1px grey solid'
    },
    leftSection: {
        paddingTop: theme.spacing(2),
        paddingBottom: theme.spacing(2),
        display: 'flex',
        justifyContent: 'space-evenly',
        alignItems: 'center',
        paddingRight: theme.spacing(2),
        paddingLeft: theme.spacing(2),
    },
    rightSection: {
        paddingTop: theme.spacing(2),
        paddingBottom: theme.spacing(2),
        paddingLeft: theme.spacing(3),
        borderLeft: '1px grey solid',
        backgroundColor: theme.palette.grey[800],
        color: theme.palette.grey[500],
    }
}))
const ColorButton = withStyles((theme) => ({
    root: {
        backgroundColor: 'none',
        width: '210px ',
        borderRadius: 4,
        border: 'solid 2px orange',
        color: 'orange',
        height: 42
    },
    disabled: {
        border: 'solid 2px #595959',
        color: '#595959 !important',
    }
}))(Button);

function SearchActionsSection(props) {
    const classes = useStyle();
    const {t} = useTranslation('payrollAdjustment');
    const { partners, selectListGroup, airports, isSelected, handleActive } = props;
    const [searchKeys, setSearchKeys] = useState([null, null, null, null]);
    const [searchInputKeys, setSearchInputKeys] = useState([null, null, null]);
    const theme = useTheme();
    const userPref = getUserPreference();
    const tokenContents = useToken();
    const ableManagerAccess = tokenContents.uiAbilities.includes(MANAGER_ACCESS_ROLE);

    const branchList = useSelector(state => state.common.branches);

    const [selectedWarehouses, setSelectedWarehouses] = useState([]);
    const [all, setAll] = useState(false);
    const [selectedWarehousesStr, setSelectedWarehousesStr] = useState('');

    const handleSearchKeys = (value, index, searchKeys) => {
        let arr = _.cloneDeep(searchKeys);
        if (index === 2) {
            arr[index + 1] = null;
        }
        arr[index] = value
        setSearchKeys(arr);
    }
    const handleInputKeys = (value, index, inputKeys) => {
        let arr = _.cloneDeep(inputKeys);
        arr[index] = value;
        setSearchInputKeys(arr);
    }

    useEffect(() => {
        if (all) {
            setSelectedWarehouses([]);
            setSelectedWarehousesStr('ALL');
        } else {
            if (selectedWarehouses?.length > 0) {
                let arr = [];
                selectedWarehouses.map((warehouse) => {
                    arr.push(warehouse.id);
                })
                setSelectedWarehousesStr(arr.toString());
            } else {
                setSelectedWarehousesStr(userPref.userCity.toString());
            }
        }
    }, [selectedWarehouses, all])

    return (
        <Box className={classes.root}>
            <Grid
                container
                alignItems="center"
                justify="center"
                justifyContent="flex-end"
                style={{flexGrow: 1}}
            >
                <Grid
                    alignItems="center"
                    justify="center"
                    xs={8}
                    item
                    justifyContent="flex-end"
                    style={{flexGrow: 1}}
                >
                    <div className={classes.leftSection}>
                        {
                            selectListGroup?.length > 0 &&
                            selectListGroup.map((selectList, i) => (
                                <Grid xs={selectList.length} item style={{marginLeft: 5}}>
                                    {selectList && selectList.id === 0 ?
                                        <FormControl
                                            variant="outlined"
                                            size="small"
                                            style={{width: '100%'}}
                                        >
                                            <InputLabel style={{fontSize: 13}}>{selectList.label}</InputLabel>
                                            <Select
                                                value={searchKeys[i]}
                                                id="searchactionssection_paymentcycle_select"
                                                onChange={(event) => {
                                                    handleSearchKeys(event.target.value, i, searchKeys)
                                                }}
                                            >
                                                <MenuItem key={"currentPayrollCycles"}
                                                          value={selectList.list?.currentPayrollCycles}>{t('current')}:{selectList.list?.currentPayrollCycles}</MenuItem>
                                                <MenuItem key={"nextPayrollCycle"}
                                                          value={selectList.list?.nextPayrollCycle}>{t('next_pay')}:{selectList.list?.nextPayrollCycle}</MenuItem>
                                                <Divider variant="high" color='black'/>
                                                <span style={{marginLeft: '20px'}}>  {t('last_three_month')}:</span>
                                                {
                                                    selectList.list?.lastThreeMonthPayrollCycles?.map((item) => {
                                                        return <MenuItem style={{marginLeft: '40px'}} key={item}
                                                                         value={item}>{item}</MenuItem>
                                                    })}
                                            </Select>
                                        </FormControl>
                                        :
                                        (
                                            selectList && selectList.id === 3 ?
                                                <FormControl
                                                    variant="outlined"
                                                    size="small"
                                                    style={{width: '100%'}}
                                                    display='block'
                                                >
                                                    <InputLabel style={{fontSize: 12}}>{selectList.label}</InputLabel>
                                                    <Select
                                                        value={searchKeys[i]}
                                                        onChange={(event) => {
                                                            handleSearchKeys(event.target.value, i, searchKeys)
                                                        }}
                                                        id="searchactionssection_searchkeys_select"
                                                    >
                                                        {
                                                            searchKeys[i - 1] && !_.isNil(props?.chargeReason) && (searchKeys[i - 1] === -1 || searchKeys[i - 1] === props?.chargeReason[0]?.id) &&
                                                            <span
                                                                style={{marginLeft: '20px'}}>{!_.isNil(props?.chargeReason) && props?.chargeReason[0]?.label}:</span>
                                                        }
                                                        {
                                                            searchKeys[i - 1] && (searchKeys[i - 1] === -1 || searchKeys[i - 1] === props?.chargeReason[0]?.id)
                                                            && !_.isNil(props?.chargeReason) && props.chargeReason[0]?.reasons?.map((item) => {
                                                                return <MenuItem style={{marginLeft: '40px'}} key={item.id}
                                                                                 value={item.id}>{item.name}</MenuItem>
                                                            })
                                                        }
                                                        {
                                                            searchKeys[i - 1] && !_.isNil(props?.chargeReason) && (searchKeys[i - 1] === -1 || searchKeys[i - 1] === props?.chargeReason[1]?.id) &&
                                                            <span
                                                                style={{marginLeft: '20px'}}> {!_.isNil(props?.chargeReason) && props?.chargeReason[1]?.label}:</span>
                                                        }
                                                        {
                                                            searchKeys[i - 1] && (searchKeys[i - 1] === -1 || searchKeys[i - 1] === props?.chargeReason[1]?.id)
                                                            && !_.isNil(props?.chargeReason) && props.chargeReason[1]?.reasons.map((item) => {
                                                                return <MenuItem style={{marginLeft: '40px'}} key={item.id}
                                                                                 value={item.id}>{item.name}</MenuItem>
                                                            })
                                                        }
                                                    </Select>
                                                </FormControl>
                                                :
                                                <FormControl
                                                    variant="outlined"
                                                    size="small"
                                                    style={{width: '100%'}}

                                                >
                                                    <InputLabel style={{fontSize: 11}}>{selectList.label}</InputLabel>
                                                    <Select
                                                        value={searchKeys[i]}
                                                        onChange={(event) => {
                                                            handleSearchKeys(event.target.value, i, searchKeys)
                                                        }}
                                                        id="searchactionssection_searchkeys_select"
                                                    >
                                                        {selectList.list?.map((item) => {
                                                            return <MenuItem key={item.id}
                                                                             value={item.value}>{t(item.text)}</MenuItem>
                                                        })}
                                                    </Select>
                                                </FormControl>
                                        )
                                    }
                                </Grid>
                            ))
                        }
                        {
                            props.inputList &&
                            props.inputList.map((inputList, i) => (
                                inputList?.specificSign === true ?
                                    <Grid xs={2} item style={{marginLeft: '20px'}}>
                                        <Grid
                                            container
                                            alignItems="center"
                                            justify="center"
                                            justifyContent="flex-end"
                                        >
                                            <Grid xs={11} item>
                                                <FormControl variant="outlined" size="small">
                                                    <InputLabel
                                                        shrink={true}
                                                    >
                                                        {inputList.label}
                                                    </InputLabel>
                                                    <OutlinedInput
                                                        value={searchInputKeys[i]}
                                                        id="searchactionssection_searchinputkeys_outlinedinput"
                                                        onChange={(event) => {
                                                            handleInputKeys(event.target.value, i, searchInputKeys)
                                                        }}
                                                    />
                                                </FormControl>
                                            </Grid>
                                            <Grid xs={1} item>
                                                <RemoveIcon style={{
                                                    size: 'small',
                                                    color: 'gray',
                                                    marginTop: '6px',
                                                    marginRight: '5px'
                                                }}/>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                    :
                                    <Grid xs={2} item style={{marginLeft: '7px'}}>
                                        <FormControl variant="outlined" style={{width: '100%', marginLeft: '5px'}}
                                                     size="small">
                                            <InputLabel
                                                shrink={true}
                                            >
                                                {inputList.label}
                                            </InputLabel>
                                            <OutlinedInput
                                                value={searchInputKeys[i]}
                                                id="searchactionssection_searchKeys_select"
                                                onChange={(event) => {
                                                    handleInputKeys(event.target.value, i, searchInputKeys)
                                                }}
                                            />
                                        </FormControl>
                                    </Grid>
                            ))
                        }
                    </div>
                </Grid>
                <Grid item xs={1} alignItems="center" justify="center">
                    <IconButton
                        color='primary'
                        onClick={() => props.onSearch(searchKeys, searchInputKeys, selectedWarehousesStr)}
                        style={{width: '40px', height: '40px', backgroundColor: 'gray'}}
                        id="searchactionssection_searchkeys_iconbutton"
                    >
                        <Search style={{
                            color: 'white', width: '21.9px',
                            height: '21.9px'
                        }}/>
                    </IconButton>
                    <IconButton
                        color='primary'
                        onClick={() => props.onDownload(searchKeys, searchInputKeys)}
                        style={{width: '40px', height: '40px'}}
                        id="searchactionssection_searchdownload_iconbutton"
                    >
                        <CloudDownload style={{
                            color: 'light', width: '21.9px',
                            height: '21.9px',
                        }}/>
                    </IconButton>
                </Grid>
                <Grid
                    xs={3}
                    justify="flex-end"
                    container
                    style={{flexGrow: 1}}
                >
                    {
                        props.buttonGroup &&
                        props.buttonGroup?.map((button, i) => (
                            button.colorButton === true ?
                                <ColorButton
                                    variant="outlined"
                                    color="primary"
                                    size="medium"
                                    onClick={() => props.handleClickButtonACtion(i)}
                                    style={{marginLeft: 10, fontSize: '13px', marginTop: 2}}
                                >
                                    {button.label}
                                </ColorButton>
                                :
                                (
                                    ((props.ableManagerAccess === true && props.status === 2) || (props.ableManagerAccess === false && props.status === 1)) &&
                                    <Button
                                        variant="contained"
                                        color="primary"
                                        size="medium"
                                        disabled={props.disableSubmitButton}
                                        onClick={() => props.handleClickButtonACtion(i)}
                                        justifyContent="flex-end"
                                        style={{
                                            marginLeft: 10,
                                            width: '210px',
                                            fontSize: '13px',
                                            height: 42,
                                            marginTop: 2
                                        }}
                                    >
                                        {button.label}
                                    </Button>
                                )
                        ))
                    }
                </Grid>
                {
                    ableManagerAccess &&
                    <Grid
                        item
                        container
                        xs={12}
                        style={{
                            flexGrow: 1,
                            marginLeft: 20,
                            marginBottom: 10
                        }}>
                        <Grid item xs={7}>
                            <Autocomplete
                                disabled={all}
                                multiple
                                options={branchList || []}
                                getOptionLabel={(option) => option.name}
                                onChange={(event, value) => {
                                    setSelectedWarehouses(value)
                                }}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        variant="outlined"
                                        label={t('warehouses')}
                                    />
                                )}
                                fullWidth
                                value={selectedWarehouses}
                            />
                        </Grid>
                        <Grid item xs={3} style={{ display: 'flex', alignItems: 'center' }}>
                            <Checkbox
                                color="primary"
                                onClick={() => setAll(!all)}
                                checked={all}
                            />
                            <span style={{ color: 'white' }}>{t('common:all')}</span>
                        </Grid>
                    </Grid>
                }
            </Grid>
        </Box>
    );
}

export default SearchActionsSection;